
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/ot-vendor-access",
      function () {
        return require("private-next-pages/learn/ot-vendor-access.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/ot-vendor-access"])
      });
    }
  